function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M389,76h-45V27.2c0-6.2-5.1-11.2-11.2-11.2h-7.5c-6.2,0-11.2,5.1-11.2,11.2V76H134V27.2 c0-6.2-5.1-11.2-11.2-11.2h-7.5c-6.2,0-11.2,5.1-11.2,11.2V76H59c-24.8,0-45,20.2-45,45v330c0,24.8,20.2,45,45,45h330 c24.8,0,45-20.2,45-45V121C434,96.2,413.8,76,389,76z M59,106h330c8.2,0,15,6.8,15,15v45H44v-45C44,112.8,50.8,106,59,106z M389,466 H59c-8.2,0-15-6.8-15-15V196h360v255C404,459.2,397.2,466,389,466z M152.8,316h-37.5c-6.2,0-11.2-5.1-11.2-11.2v-37.5 c0-6.2,5.1-11.2,11.2-11.2h37.5c6.2,0,11.2,5.1,11.2,11.2v37.5C164,310.9,158.9,316,152.8,316z M242.8,316h-37.5 c-6.2,0-11.2-5.1-11.2-11.2v-37.5c0-6.2,5.1-11.2,11.2-11.2h37.5c6.2,0,11.2,5.1,11.2,11.2v37.5C254,310.9,248.9,316,242.8,316z  M332.8,316h-37.5c-6.2,0-11.2-5.1-11.2-11.2v-37.5c0-6.2,5.1-11.2,11.2-11.2h37.5c6.2,0,11.2,5.1,11.2,11.2v37.5 C344,310.9,338.9,316,332.8,316z M242.8,406h-37.5c-6.2,0-11.2-5.1-11.2-11.2v-37.5c0-6.2,5.1-11.2,11.2-11.2h37.5 c6.2,0,11.2,5.1,11.2,11.2v37.5C254,400.9,248.9,406,242.8,406z M152.8,406h-37.5c-6.2,0-11.2-5.1-11.2-11.2v-37.5 c0-6.2,5.1-11.2,11.2-11.2h37.5c6.2,0,11.2,5.1,11.2,11.2v37.5C164,400.9,158.9,406,152.8,406z M332.8,406h-37.5 c-6.2,0-11.2-5.1-11.2-11.2v-37.5c0-6.2,5.1-11.2,11.2-11.2h37.5c6.2,0,11.2,5.1,11.2,11.2v37.5C344,400.9,338.9,406,332.8,406z"
});

var SvgIconOrdersList = function SvgIconOrdersList(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 448 512",
    style: {
      enableBackground: "new 0 0 448 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconOrdersList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_orders_list.4a8b9666.svg";
export { ForwardRef as ReactComponent };